// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTheme } from '@mui/material';

import Tile, { TileProps } from '@components/Timeline/Tile/Tile';
import TileIconUber from '@components/Timeline/Tile/TileIconUber';

// TYPES ---------------------------------------------------------------- //

export interface UberRideProps
  extends Omit<
    TileProps,
    'color' | 'extraWidthBeforeLabel' | 'extraWidthBetweenLabel' | 'extraWidthAfterLabel' | 'secondaryIcon' | 'variant'
  > {}

// COMPONENT ---------------------------------------------------------------- //

const UberRide = ({ ...props }: UberRideProps) => {
  const theme = useTheme();

  return (
    <Tile
      color={theme.palette.uber.main}
      extraWidthBeforeLabel={`WAIT`}
      extraWidthBetweenLabel={`???`}
      extraWidthAfterLabel={`RIDE`}
      secondaryIcon={<TileIconUber />}
      variant={`outlined`}
      {...props}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default UberRide;
